module.exports = __webpack_public_path__ + "static/media/img_Benchmarking204.f795d509.png";